import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useSessionAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import { useMembershipModalState } from '../../../../modalContext';

type Result = {
	headline: string;
	description: string;
	isSunriseEnabled: boolean;
};

export function useHeader(): Result {
	const [{ isSunriseEnabled, useDonationLanguage, koiPpmuDesignExperimentVariant }] = useMembershipModalState();
	const { translate } = useI18n();
	const session = useSessionAsync();

	const { headline, description } = useMemo(() => {
		if (!isLoaded(session)) {
			return { headline: '', description: '' };
		}

		const isGuest = session.value.loginState === 'GUEST';
		const shortDisplayName = session.value.user?.shortDisplayName ?? '';
		const descriptionSuffix = useDonationLanguage ? '_donation' : '';
		const headlineSuffix = isGuest ? '_guest' : '';
		return {
			headline:
				koiPpmuDesignExperimentVariant === 'variant_2'
					? translate(`corgi.co.ppmu.modal.headline${headlineSuffix}`, { name: shortDisplayName })
					: translate(`corgi.co.ppmu.modal.heading${headlineSuffix}`, { name: shortDisplayName }),
			description:
				koiPpmuDesignExperimentVariant === 'variant_2'
					? translate(`corgi.co.ppmu.modal.description${descriptionSuffix}`)
					: translate('corgi.co.ppmu.modal.subheading'),
		};
	}, [koiPpmuDesignExperimentVariant, session, translate, useDonationLanguage]);

	return {
		headline,
		description,
		isSunriseEnabled,
	};
}
